'use client'

import React, { useEffect } from 'react'

import { brand } from '@/utils/brand'

const TrustpilotSection: React.FC = () => {
  const { trustpilotBusinessUnitId, trustpilotCTA } = brand.pageContent.Reviews

  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    script.async = true
    document.head.appendChild(script)

    return () => {
      // Cleanup script when component unmounts
      const existingScript = document.querySelector(
        'script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]',
      )
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])

  return (
    <div className="mx-auto pt-16">
      <div className="mx-auto max-w-[1056px] px-6">
        {/* Trustpilot Widget */}
        <div className="mb-16">
          <div
            className="trustpilot-widget"
            data-businessunit-id={trustpilotBusinessUnitId}
            data-locale="en-US"
            data-schema-type="Organization"
            data-stars="4,5"
            data-review-count="46211"
            data-style-height="1400px"
            data-style-width="100%"
            data-template-id="539adbd6dec7e10e686debee"
            data-theme="light"
          >
            <a
              href={`https://www.trustpilot.com/review/${brand.key}.com`}
              rel="noopener noreferrer"
              target="_blank"
            >
              Trustpilot
            </a>
          </div>
        </div>

        <div className="mb-16 text-center">
          <p className="text-lg text-gray-600">
            <a
              href={
                `https://www.trustpilot.com/review/${brand.key}.com?` +
                'utm_medium=trustbox&utm_source=Grid'
              }
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-600 underline hover:text-green-700"
            >
              {trustpilotCTA}
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default TrustpilotSection
